import { Link } from "../../../util/router";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { plans } from "../../../components/PricingSectionCommon"

export default function TpPackages() {
  const tpm_plan = plans.find(p => p.id === "tpm")
  const tp_plan = plans.find(p => p.id === "tp")

  return (
    <div className="bg-white py-12 sm:py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Single CTA - billing selection happens on checkout page */}
        <div className="bg-green-700 rounded-2xl p-8 mb-12">
          <h2 className="text-3xl font-bold text-white text-center mb-4">
            Ready to Take Your Agency to the Next Level?
          </h2>
          <p className="text-green-100 text-center mb-6 text-lg">
            Get everything you need to grow your agency with our comprehensive training package.
          </p>

          <div className="bg-white rounded-xl p-6 max-w-2xl mx-auto">
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">What's Included</h3>
            <div className="grid sm:grid-cols-2 gap-3 mb-6">
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">10 team seats included</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">$3,000 Non-Compete Agreement</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">Comprehensive Staff Handbook</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">Million Dollar Manual</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">All 7 Sales Processes</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">Stairs and Buckets included</span>
              </div>
            </div>

            <div className="text-center">
              <p className="text-gray-600 text-sm mb-4">Choose monthly or annual billing on the next page</p>
              <Link
                to="/checkout?product=tp"
                className="inline-block w-full sm:w-auto bg-green-600 text-white font-bold py-3 px-10 rounded-lg text-lg hover:bg-green-700 transition-colors"
              >
                Get Started Now
              </Link>
            </div>
          </div>

          <p className="text-center text-green-100 mt-6 text-sm">
            100% Money-Back Guarantee within 3 days. No questions asked.
          </p>
        </div>
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
          <p className="text-base/7 font-semibold text-green-600">Agency Training Package</p>
          <h1 className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Pricing and Features
          </h1>
          <div className="mt-10 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Pricing</h2>
              <p className="mt-4">
                <strong>Monthly Plan:</strong> ${tpm_plan.price} per month<br />
                <strong>Annual Plan:</strong> ${tp_plan.price} per year
              </p>
            </div>

            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Core Offer and Features</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li><strong>Stairs And Buckets:</strong> Core foundational process included.</li>
                <li><strong>All Seven Sales Processes:</strong> Comprehensive strategies for diverse client needs.</li>
                <li><strong>Agency Training Manual:</strong> Gold-standard resource for team development.</li>
                <li><strong>Staff Handbook:</strong> Policies and legal protection for your agency.</li>
                <li><strong>Non-Compete Clause Template:</strong> Protects business interests.</li>
                <li><strong>Two Books:</strong> Proven strategies for success.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none my-8">
          <h1 className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Detailed Features
          </h1>
          <div className="mt-10 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">The Seven Sales Processes</h2>
              <p>These processes align with clients’ unique needs and risks at every stage of life:</p>
              <ul className="mt-4 space-y-4 text-start">
                <li><strong>Stairs and Buckets:</strong> Foundational process for success.</li>
                <li><strong>Medicare 101:</strong> Simplifies Medicare education for clients, increasing understanding and confidence.</li>
                <li><strong>Large Premium Life with FCB Rider:</strong> A targeted strategy to secure large premium life insurance clients.</li>
                <li><strong>Finding the Money:</strong> Helps identify clients’ budget potential and untapped financial resources.</li>
                <li><strong>Protect and Participate:</strong> Balances market participation and protection for client investments.</li>
                <li><strong>Understanding Money:</strong> Educates clients on fundamental money principles for informed decision-making.</li>
                <li><strong>Liability Wall:</strong> Shields clients from financial risks such as liability and home damage.</li>
              </ul>
            </div>

            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Agency Training Manual</h2>
              <p>This manual serves as the gold standard for training teams in insurance sales:</p>
              <ul className="mt-4 space-y-4 text-start">
                <li><strong>Developing Your Team’s Why:</strong> Builds motivation and purpose.</li>
                <li><strong>Telephone and Email Skills:</strong> Mastering communication essentials.</li>
                <li><strong>Lapse Can Strategies:</strong> Techniques to recover and retain lapsed policies.</li>
                <li><strong>Auto and Home Strategies:</strong> Cross-selling for maximum value.</li>
                <li><strong>Liability, Life, and Health Processes:</strong> Essential frameworks for key insurance products.</li>
                <li><strong>FORM Strategy:</strong> A customer-centric conversational guide focused on Family, Occupation, Recreation, and Money.</li>
                <li><strong>Characteristics of a Successful Team:</strong> Identifies skills needed for success in insurance sales.</li>
                <li><strong>Partner Resources:</strong> Tools and tips for strengthening networks and partnerships.</li>
              </ul>
            </div>
          </div>

          <div className="mt-10 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Staff Handbook</h2>
              <p>A comprehensive guide for team onboarding and management:</p>
              <ul className="mt-4 space-y-4 text-start">
                <li><strong>Policies and Procedures:</strong> Clear job descriptions, daily operating schedules, and financial management policies.</li>
                <li><strong>Agency Security Protocols:</strong> Ensures compliance and security.</li>
                <li><strong>Harassment Policies:</strong> Includes hiring and termination procedures.</li>
                <li><strong>Non-Compete Agreement:</strong> A $3,000 legal document crafted by an attorney to protect your client base.</li>
              </ul>
            </div>

            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Books</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li><strong>Paychecks Never Lie:</strong> Focuses on improving business results, coaching strategies, and actionable practices.</li>
                <li><strong>BIGGER PAYCHECK$, BETTER PAYCHECK$</strong> Emphasizes small, consistent improvements for big results over time.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
